import React from 'react';
import PostPaymentContractProductsList from './PostPaymentContractProductsList';
import UpfrontContractProductsList from './UpfrontContractProductsList';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { BRAZIL } from '../../../core/consts';
import UpgradeContractFormService from '../services/UpgradeContractFormService';

class UpgradeContractProductsListContainer extends React.Component {
  render() {
    const contractType = toJS(UpgradeContractFormService.contract.type);
    const currencyType =
      !UpgradeContractFormService.form.getValue('country') ||
      BRAZIL.includes(UpgradeContractFormService.form.getValue('country'))
        ? 'real'
        : 'dollar';

    if (contractType === 'UPFRONT') {
      return (
        <UpfrontContractProductsList
          disabled={UpgradeContractFormService.fetch.fetching || UpgradeContractFormService.submit.fetching}
          onDelete={UpgradeContractFormService.productsService.handleDelete}
          onEdit={UpgradeContractFormService.productsService.handleEdit}
          data={toJS(UpgradeContractFormService.productsService.contractProducts)}
          loading={UpgradeContractFormService.fetch.fetching}
          submitting={UpgradeContractFormService.submit.fetching}
          currencyType={currencyType}
          onToggleProduct={UpgradeContractFormService.productsService.handleToggleProduct}
        />
      );
    }

    return (
      <PostPaymentContractProductsList
        disabled={UpgradeContractFormService.fetch.fetching || UpgradeContractFormService.submit.fetching}
        onDelete={UpgradeContractFormService.productsService.handleDelete}
        onEdit={UpgradeContractFormService.productsService.handleEdit}
        data={toJS(UpgradeContractFormService.productsService.contractProducts)}
        loading={UpgradeContractFormService.fetch.fetching}
        submitting={UpgradeContractFormService.submit.fetching}
        currencyType={currencyType}
      />
    );
  }
}

export default observer(UpgradeContractProductsListContainer);
